import {
  KnownHubDetailsDtoType,
  TowerModelDto,
  TowerModelLockerLayoutDto
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { PixelDimensions2D } from '../../../../../features/lockers/models/pixel-dimensions-2d.model';
import { PixelPosition2D } from '../../../../../features/lockers/models/pixel-position-2d.model';
import { lockerSizeToLockerIconMap } from '../../../../../features/lockers/logic/locker-ui.constants';
import { Kiosk } from '../../icons/Kiosk.icon';
import { LockerRenderData, TowerRenderData } from './tower-renderer.types';

const CM_TO_PX_RATIO = 1;

/**
 * Maps a TowerModelDto (from /tower-models API) into TowerRenderData for preview rendering.
 * Uses lockerLayouts from the model to draw locker tiles with correct positions and dimensions.
 */
export function mapTowerModelToRenderData(
  model: TowerModelDto,
  index: number,
  inventoryID?: string,
  lockerStartIndex = 0,
  hubType?: KnownHubDetailsDtoType
): TowerRenderData {
  const uiDims = model.uiDimensions;
  const lockerLayouts = model.uiLockerLayouts ?? [];

  const towerWidth = uiDims?.widthCm ?? model.widthCm;
  const towerHeight = uiDims?.heightCm ?? model.heightCm;

  const lockers: LockerRenderData[] = lockerLayouts.map((layout: TowerModelLockerLayoutDto, lockerIndex: number) => {
    const isKiosk = model.kioskPosition !== undefined && lockerIndex === model.kioskPosition;
    const sizeName = layout.sizeName ?? '';

    return {
      id: `preview-${index}-locker-${lockerIndex}`,
      name: isKiosk ? '' : `${lockerStartIndex + lockerIndex + 1}`,
      sizeName,
      sizeIcon: isKiosk ? Kiosk : lockerSizeToLockerIconMap(false, sizeName),
      isKiosk,
      pixelDimensions2D: new PixelDimensions2D(
        layout.uiOuterDimensions.widthCm,
        layout.uiOuterDimensions.heightCm,
        CM_TO_PX_RATIO
      ),
      pixelPosition2D: new PixelPosition2D(layout.uiPosition.x, layout.uiPosition.y, CM_TO_PX_RATIO),
      invertedPixelPosition2D: new PixelPosition2D(
        towerWidth - layout.uiPosition.x - layout.uiOuterDimensions.widthCm,
        layout.uiPosition.y,
        CM_TO_PX_RATIO
      ),
      backgroundColor: '#FFFFFF'
    };
  });

  return {
    id: `preview-tower-${index}`,
    title: `Tower ${index}${inventoryID ? ` (${inventoryID})` : ''}`,
    isDoubleSided: model.isDoubleSided,
    pixelDimensions2D: new PixelDimensions2D(towerWidth, towerHeight, CM_TO_PX_RATIO),
    hubType,
    lockers
  };
}
